import { Next, ButtonColor } from '@shipengine/giger';
import { useSupportCenter, SUPPORT_CENTER_KEYS } from '@packlink/provider';
import { useTranslation } from '@packlink/translation-provider';
import useSendMetrics from '../../../hooks/useSendMetrics.js';
import { TrackingDetailsMetricsEvent } from '../../../types.js';
import { jsx } from '@emotion/react/jsx-runtime';

function ContactLink(_ref) {
  let {
    shipmentReference,
    isFullWidth,
    ...rest
  } = _ref;
  const {
    t
  } = useTranslation();
  const sendEvent = useSendMetrics();
  const contactUrl = useContactUrl(shipmentReference);
  return jsx(Next.Link, {
    isButton: true,
    buttonProps: {
      isFullWidth,
      color: ButtonColor.PRIMARY
    },
    isExternal: true,
    href: contactUrl,
    onClick: () => sendEvent(TrackingDetailsMetricsEvent.OnClickContactCenter),
    target: "_blank",
    ...rest,
    children: t('tracking-details.help.contact-us')
  });
}
function useContactUrl(shipmentReference) {
  const getSupportCenter = useSupportCenter();
  return getSupportCenter(SUPPORT_CENTER_KEYS.newTicket, {
    shipmentReference
  });
}

export { ContactLink };
//# sourceMappingURL=ContactLink.js.map
